import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStepCurrent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path fill="#5C37EB" d="M.75 8a7.25 7.25 0 1 1 14.5 0A7.25 7.25 0 0 1 .75 8" />
    <path
      stroke="#5C37EB"
      strokeWidth={1.5}
      d="M.75 8a7.25 7.25 0 1 1 14.5 0A7.25 7.25 0 0 1 .75 8Z"
    />
    <circle cx={8} cy={8} r={4} fill="#fff" />
  </svg>
);
export default SvgStepCurrent;
